import React from 'react';
import { COMPANY_IDS } from '../../../services/newItemWizardService';
import { C, CARD, H2, SUB, Notice } from './ui';
import { companyName } from './wizardLogic';

const optionStyle = (active, disabled) => ({
    display: 'flex', alignItems: 'center', gap: '0.75rem', width: '100%', textAlign: 'left',
    padding: '0.85rem 1rem', minHeight: '56px', borderRadius: '10px', cursor: disabled ? 'not-allowed' : 'pointer',
    border: active ? `2px solid ${C.primary}` : `1px solid ${C.lineStrong}`,
    background: active ? C.infoBg : '#FFFFFF', color: C.ink, opacity: disabled && !active ? 0.6 : 1,
});

// Paso 1: empresa principal (radio) + adicionales (checkbox).
export default function CompaniesStep({ draft, locked, onChange }) {
    const main = draft.mainCompany;
    const additional = draft.additional;
    const toggleAdditional = (id) => {
        const next = additional.indexOf(id) >= 0 ? additional.filter((x) => x !== id) : additional.concat(id);
        onChange(main, COMPANY_IDS.filter((x) => next.indexOf(x) >= 0));
    };

    return (
        <div style={CARD}>
            <h2 style={H2}>Where will this item be created?</h2>
            <p style={SUB}>The main company is completed first (product line, vendor, item and prices), then each additional company.</p>

            {locked && <Notice kind="info">Companies can't be changed anymore: some records were already sent to Sage.</Notice>}

            <fieldset style={{ border: 'none', margin: '1rem 0 0', padding: 0 }} disabled={locked}>
                <legend style={{ fontSize: '0.85rem', fontWeight: 700, color: C.text, marginBottom: '0.5rem' }}>Main company <span style={{ color: '#DC2626' }}>*</span></legend>
                <div className="row g-2">
                    {COMPANY_IDS.map((id) => (
                        <div className="col-12 col-md-6" key={id}>
                            <label style={optionStyle(main === id, locked)}>
                                <input
                                    type="radio" name="mainCompany" checked={main === id}
                                    onChange={() => onChange(id, additional.filter((x) => x !== id))}
                                    style={{ width: '18px', height: '18px', accentColor: C.primary }}
                                />
                                <span>
                                    <span style={{ display: 'block', fontWeight: 700 }}>{companyName(id)}</span>
                                    <span style={{ fontSize: '0.78rem', color: C.faint }}>Company {id}</span>
                                </span>
                            </label>
                        </div>
                    ))}
                </div>
            </fieldset>

            <fieldset style={{ border: 'none', margin: '1.25rem 0 0', padding: 0 }} disabled={locked}>
                <legend style={{ fontSize: '0.85rem', fontWeight: 700, color: C.text, marginBottom: '0.5rem' }}>Also create it in</legend>
                <div className="row g-2">
                    {COMPANY_IDS.filter((id) => id !== main).map((id) => (
                        <div className="col-12 col-md-6" key={id}>
                            <label style={optionStyle(additional.indexOf(id) >= 0, locked)}>
                                <input
                                    type="checkbox" checked={additional.indexOf(id) >= 0}
                                    onChange={() => toggleAdditional(id)}
                                    style={{ width: '18px', height: '18px', accentColor: C.primary }}
                                />
                                <span>
                                    <span style={{ display: 'block', fontWeight: 700 }}>{companyName(id)}</span>
                                    <span style={{ fontSize: '0.78rem', color: C.faint }}>Uses its own product line and vendor</span>
                                </span>
                            </label>
                        </div>
                    ))}
                </div>
            </fieldset>

            <Notice kind="info">
                Order: <b>{[main].concat(additional).map(companyName).join(' → ')}</b>. The item code and barcodes are the same in every company.
            </Notice>
        </div>
    );
}
